import Cookies from 'js-cookie';
import { utils } from 'utils';

export const SECURITY_CDN_COOKIE = '_security_script_cdn';

const OLD_CDN_BASE = 'https://d3oj4llvjybnfh.cloudfront.net/cdn/ca';
const NEW_CDN_BASE = 'https://iamg2.guesty.com/cdn/ca';

export const getScriptUrl = () => {
  const useNewCdn = Cookies.get(SECURITY_CDN_COOKIE) === 'true';
  const baseUrl = useNewCdn ? NEW_CDN_BASE : OLD_CDN_BASE;
  const scriptName = utils.isHQDomain
    ? 'guesty-hq-arc.js?a=1232a719e4d1df5e0c4e3ce9cdfeda1f'
    : 'guesty-app-arc.js?a=70f09922bfec379ba20c8c1abb4a6e17';

  return `${baseUrl}/${scriptName}`;
};

export const createSecurityScript = (scriptSrc, onSuccess, onError) => {
  const script = document.createElement('script');
  script.src = scriptSrc;
  script.defer = true;
  script.referrerPolicy = 'strict-origin-when-cross-origin';
  script.onload = onSuccess;
  script.onerror = onError;
  return script;
};

export const isScriptAlreadyLoaded = scriptSrc => {
  return Boolean(document.querySelector(`script[src="${scriptSrc}"]`));
};

export const isLiteActivation = (isActivationFlow, packageName) => {
  return isActivationFlow && packageName === 'lite';
};
